module.exports = __webpack_public_path__ + "img/insure-notice-head.b0cc23ef.png";